'use client';

import { useAuth } from '@/contexts/auth-context';
import { isSuperAdmin, hasAnyPermission } from '../utils/permissions';

interface PermissionGateProps {
  children: React.ReactNode;
  permissions: string[];
  fallback?: React.ReactNode;
}

export function PermissionGate({
  children,
  permissions,
  fallback = null
}: PermissionGateProps) {
  const { user } = useAuth();

  if (!user) return fallback;
  if (isSuperAdmin(user)) return <>{children}</>;
  if (!hasAnyPermission(user, permissions)) return fallback;

  return <>{children}</>;
}
